<template>
  <div class="header-container">
    <div class="school-logo">
      <div class="logo"></div>
      <div class="head_title">四川大学高等教育自学考试-校外教学点申请系统</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHead',
  data () {
    return {
      showUserName: false
    }
  },
  computed: {
    userName () {
      return this.$store.state.userName
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    quit () { // 退出到登录页
      this.$store.commit('userExit')
    }
  }
}
</script>

<style scoped lang="less">
.header-container{
  display: flex;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #ba2a17;
  .school-logo{
    // width: ;
    width: 1080px;
    margin-left: 12%;
    // margin: auto;
    display: flex;
    height: 100px;
    // flex-direction: column;
    // justify-content: center;
    align-items: center;
    .logo{
      height: 87px;
      width: 370px;
      background: url("../assets/home/logo.png") no-repeat 0 0;
      background-size: 100% 100%;
    }
    .head_title{
      font-size: 28px;
      line-height: 1;
      color: white;
      margin-left: 58px;
    }
  }
  .school-name{
    margin-left: 6vw;
    line-height: 100px;
    color: white;
    letter-spacing: 3px;
  }
  .user-handle{
    margin-left: auto;
    display: flex;
    align-items: center;
    color: white;
    .exit{
      margin-left: 30px;
    }
  }
}
@media screen and (max-width: 1366px){
  .school-logo{
    margin-left: 50px !important;
  }
  .school-name{
    margin-left: 4vw !important;
  }
  .user-handle{
    .exit{
      margin-left: 20px !important;
    }
  }
}
</style>
